<template>
  <div
    v-loading="page.loading"
    class="condition-tabs"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
  >
    <table
      border="0"
      cellspacing="0"
    >
      <transition-group
        name="el-zoom-in-top"
        tag="tbody"
      >
        <slot name="first" />
        <template v-for="item in condition.filter(itm => !itm.tabs || itm.tabs.length > 0)">
          <!-- 日期选择类 -->
          <tr
            v-if="cp_datarange.includes(item.prop)"
            :key="item.prop"
            class="tab-row"
          >
            <td
              class="tab-cell tab-label"
              :style="{width: labelWidth}"
            >
              <span>{{ item.name }}</span>
            </td>
            <td
              colspan="2"
              class="tab-cell"
            >
              <el-radio-group v-model="daterangeValue[item.prop]">
                <el-radio label="0">
                  本周
                </el-radio>
                <el-radio label="2">
                  本月
                </el-radio>
                <el-radio label="more">
                  自定义时间
                </el-radio>
              </el-radio-group>
              <transition name="el-zoom-in-top">
                <div
                  v-show="daterangeValue[item.prop] === 'more'"
                  class="date-editor"
                >
                  <el-date-picker
                    v-model="daterangeValue[item.prop + 'Daterange']"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange"
                  />
                </div>
              </transition>
            </td>
          </tr>
          <!-- 国家 -->
          <tr
            v-else-if="item.prop === 'country'"
            :key="item.prop"
            class="tab-row"
          >
            <td
              class="tab-cell tab-label"
              :style="{width: labelWidth}"
            >
              <span>{{ item.name }}</span>
            </td>
            <td class="tab-cell td-all">
              <span
                :class="{selected: limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)}"
                class="item-tab"
                @click="selectTba({ prop: item.prop, selectedAll: item.selectedAll, tabs: item.tabs }, { value: item.hasOwnProperty('selectedAll') ? item.selectedAll : -1 })"
              >
                <span>{{ item.skyLabel || allSelected }}</span>
              </span>
            </td>
            <td>
              <ul class="item-tab-ul clear-fix">
                <li
                  v-for="(tab, i) in cp_country.tabs"
                  :key="i"
                  class="fl item-tab"
                  :class="{selected: !(limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)) && limit[item.prop].toString().split(',').includes(tab.value.toString())}"
                  @click="selectTba(item, tab)"
                >
                  <span>{{ tab.label }}</span>
                </li>
              </ul>
            </td>
            <td class="btn-td">
              <!-- <el-button type="primary" @click="page.moreProvinces = true" size="mini">查看更多</el-button> -->
            </td>
          </tr>
          <!-- 省份 -->
          <tr
            v-else-if="item.prop === 'provinces'"
            v-show="cp_provinces.tabs.length > 0"
            :key="item.prop"
            class="tab-row"
          >
            <td
              class="tab-cell tab-label"
              :style="{width: labelWidth}"
            >
              <span>{{ item.name }}</span>
            </td>
            <td class="tab-cell td-all">
              <span
                :class="{selected: limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)}"
                class="item-tab"
                @click="selectTba({ prop: item.prop, selectedAll: item.selectedAll, tabs: item.tabs }, { value: item.hasOwnProperty('selectedAll') ? item.selectedAll : -1 })"
              >
                <span>{{ item.skyLabel || allSelected }}</span>
              </span>
            </td>
            <td>
              <ul class="item-tab-ul clear-fix">
                <li
                  v-for="(tab, i) in cp_tabs_provinces"
                  :key="i"
                  class="fl item-tab"
                  :class="{selected: !(limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)) && limit[item.prop].toString().split(',').includes(tab.value.toString())}"
                  @click="selectTba(item, tab)"
                >
                  <span>{{ tab.label }}</span>
                </li>
              </ul>
            </td>
            <td class="btn-td check-more-btn">
              <el-button
                type="primary"
                size="mini"
                @click="page.moreProvinces = true"
              >
                查看更多
              </el-button>
            </td>
          </tr>
          <condition-row
            v-else
            :key="item.prop"
            :item="item"
            :limit="limit"
            :label-width="labelWidth"
            :all-selected="allSelected"
            :class="item.class"
            @select-all="selectTba({ prop: item.prop, selectedAll: item.selectedAll, tabs: item.tabs, beforeCheck: item.beforeCheck}, { value: item.hasOwnProperty('selectedAll') ? item.selectedAll : -1 })"
            @select-tab="selectTba"
          />
        </template>
        <slot />
      </transition-group>
    </table>
  </div>
</template>

<script>
import { getConditions } from '@/lib/utils';
import { dataFormat } from '@/lib/functional';
import api from './proxy';
import ConditionRow from './tools/ConditionRow';

export default {
    name: 'TheCondition',
    components: { ConditionRow },
    props: {
        limit: {
            type: Object,
            required: true,
        },
        agent: {
            type: Number,
            default: 0,
        },
        multiple: { // 可多选条目
            type: [String, Array],
            default () {
                return [];
            },
        },
        allSelected: {
            type: String,
            default: '全部',
        },
        config: { // 自定义选项
            type: Object,
            default () {
                return {};
            },
        },
        labelWidth: { // 自定义选项
            type: String,
            default: '120px',
        },
        lazy: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        let condition = getConditions(Object.keys(this.limit)).map(itm => {
                let multiple = (Array.isArray(this.multiple) && this.multiple || [this.multiple]).includes(itm.prop) || itm.multiple;
                if (this.config.hasOwnProperty(itm.prop)) {
                    /* 取自定义的选项 */
                    itm = Object.assign(this.config[itm.prop], Object.assign({}, itm, this.config[itm.prop]));
                }
                itm.tabs && itm.tabs.forEach(m => Object.assign(m, multiple && { selected: 0 } || {}));
                return Object.assign(itm, { multiple });
            }).filter(itm => itm.name),
            country = condition.find((itm) => itm.prop === 'country') || {},
            newprovinces = condition.find((itm) => itm.prop === 'newprovinces') || {},
            city = condition.find((itm) => itm.prop === 'city') || {},
            county = condition.find((itm) => itm.prop === 'county') || {};
        return {
            condition,
            daterangeValue: {
                operaing: null,
                operaingDaterange: null,
                loginTime: '0',
                loginTimeDaterange: null,
            },
            area: {
                allCountry: country.hasOwnProperty('selectedAll') ? country.selectedAll : -1,
                allProvinces: newprovinces.hasOwnProperty('selectedAll') ? newprovinces.selectedAll : -1,
                allCity: city.hasOwnProperty('selectedAll') ? city.selectedAll : -1,
                allCounty: county.hasOwnProperty('selectedAll') ? county.selectedAll : -1,
                provincesRecord: [],
            },
            page: {
                loading: false,
                moreProvinces: false,
            },
            moreProvinces: {
                keyword: '',
                searchWord: '',
                alphabet: Array.from({ length: 26 }).map((v, i) => {
                    return String.fromCharCode(65 + i);
                }),
                select: 'A',
            },
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now();
                },
            },
            copyLimit: {},
            filterProvArr: [],
        };
    },
    computed: {
        cp_datarange () {
            return Object.keys(this.daterangeValue);
        },
        cp_limit () {
            return Object.keys(this.limit);
        },
        cp_country () {
            return (this.condition.find(itm => itm.prop === 'country') || { tabs: [] });
        },
        cp_provinces () {
            return (this.condition.find(itm => itm.prop === 'newprovinces') || { tabs: [] });
        }, // 所有省份
        cp_tabs_provinces () {
            return [...this.area.provincesRecord, ...this.cp_provinces.tabs.filter(itm => !this.area.provincesRecord.find(re => re.value === itm.value))].slice(0, 8);
        }, // 页面显示的省份
        cp_userid () {
            return this.$store.getters['global/userId'];
        },
        cp_admin () {
            return [0, 2].includes(this.cp_org.orgType);
        }, // 是学校或代理商
        cp_org () {
            return this.$store.getters['global/currentOrg'];
        },
        cp_orgId () {
            return this.cp_org.orgId;
        },
        cp_is_useridentity () {
            return this.$store.getters['global/currentOrg'].orgId;
        },
        cp_book_keys () {
            return this.cp_limit.filter(k => [
                'periodId', // 学段
                'subjectId', // 学科
                'knowledgeType', // 知识体系分类
                'eduSystem', // 学制
                'editionId', // 版本
                'gradeId', // 年级
                'volumneId', // 必修、选修
                'status', // 启用状态
                'assistantStatus', // 启用状态 relate
                'categoryId', // 专题分类
                'teamId', // 学期
                'tagId', // 系列标签
                'assistantBrand', // 教辅品牌
            ].includes(k));
        },
    },
    watch: {
        daterangeValue: {
            deep: true,
            handler (obj) {
                /* 时间段处理 */
                this.cp_limit.forEach(key => {
                    if (Object.entries(obj).some(([k]) => k.includes(key))) {
                        let val = obj[key];
                        if (val === 'more') {
                            this.limit[key] = obj[key + 'Daterange'] || [];
                        } else if (val === 'month') {
                            let d = new Date(),
                                end = dataFormat(d);
                            d.setMonth(d.getMonth() - 1);
                            this.limit[key] = [
                                dataFormat(d),
                                end,
                            ];
                            this.$emit('limit-change');
                        } else {
                            let d = new Date(),
                                end = dataFormat(d);
                            d.setDate(d.getDate() - val);
                            this.limit[key] = [
                                dataFormat(d),
                                end,
                            ];
                            this.$emit('limit-change');
                        }
                    }
                });
            },
        },
        'limit.country' (v) {
            let provinces = this.condition.find((itm) => itm.prop === 'provinces') || {};
            this.limit.provinces = this.area.allProvinces;
            if (v === this.area.allProvinces) {
                provinces.tabs = [];
            } else {
                this.getProvinces().finally(() => {
                    this.toggleLoading(false);
                });
            }
        },
        'limit.newprovinces' (v) {
            let city = this.condition.find((itm) => itm.prop === 'city') || {};
            this.limit.city = this.area.allCity;
            if (v === this.area.allProvinces) {
                city.tabs = [];
            } else {
                this.toggleLoading(true);
                api.operatLog({
                    provinceId: v,
                    userId: this.cp_userid,
                    bindAgent: '' || this.agent,
                }).then((data) => {
                    city.tabs = data.data.list.map(itm => {
                        return {
                            label: itm.name,
                            value: itm.cityId,
                            selected: 0,
                        };
                    });
                    this.toggleLoading(false);
                }).catch(() => {
                    this.toggleLoading(false);
                });
            }
        },
        'limit.years' (v) {
            this.toggleLoading(true);
        },
        'limit.city' (v) {
            let county = this.condition.find((itm) => itm.prop === 'county') || {};
            this.limit.county = this.area.allCounty;
            this.$emit('limit-change');
            if (v === this.area.allCity) {
                county.tabs = [];
            } else {
                this.toggleLoading(true);
                api.getCounty({
                    cityId: v,
                    bindAgent: '' || this.agent,
                }).then((data) => {
                    if (data.errcode === 0) {
                        county.tabs = data.data.list.map(itm => {
                            return {
                                label: itm.name,
                                value: itm.districtId,
                                selected: 0,
                            };
                        });
                    }
                    this.toggleLoading(false);
                }).catch(() => {
                    this.toggleLoading(false);
                });
            }
        },
    },
    mounted () {
        if (!this.lazy) {
            Promise.all(this.cp_limit.filter(k => [
                'country',
                'newprovinces',
                'years',
            ].includes(k)).map((k) => {
                let fn = {
                    country: this.getCountry,
                    provinces: this.getProvinces,
                    newprovinces: this.getNewprovinces,
                    years: this.getYears,
                    module: this.getModuleNum,
                    identity: this.getIdentity,
                    cooperrationProject: this.getCooperrationProject,
                }[k];
                return fn();
            })).then((p) => {
                if (p.length === 0) return;
                p.forEach(({ data, key }) => {
                    let tabs = [],
                        item = this.condition.find((itm) => itm.prop === key);
                    if (key === 'provinces') {
                        return;
                    }
                    switch (key) {
                        case 'country': {
                            tabs = data.list.map(itm => {
                                return {
                                    label: itm.name,
                                    value: itm.countryId,
                                    selected: 0,
                                };
                            });
                        }
                            break;
                        case 'newprovinces': {
                            tabs = data.list.map(itm => {
                                return {
                                    label: itm.name,
                                    value: itm.provinceId,
                                    selected: 0,
                                };
                            });
                        }
                            break;
                        case 'years': {
                            tabs = data.list.map(itm => {
                                return {
                                    label: itm.year,
                                    value: itm.year,
                                    selected: 0,
                                };
                            });
                        }
                            break;
                    }
                    item.tabs = tabs;
                });
                this.toggleLoading(false);
            }).catch((e) => {
                this.$message.error(e.errmsg || e || '');
                this.toggleLoading(false);
            });
            Object.assign(this.daterangeValue, {
                operaing: this.limit.defaultOperaing,
                loginTime: this.limit.defaultLoginTime,
            });

            /* 教材知识点查询条件 */
            let keys = this.cp_book_keys;
            if (keys.length > 0) {
                let send = {};
                keys.forEach(k => {
                    send[k] = '';
                });
                this.queryBookLimit(send, 'sync-ready');
            }
        }
        Object.assign(this.copyLimit, this.limit);
    },
    methods: {
        selectTba ({ multiple, prop, tabs, selectedAll = -1, beforeCheck }, tab) {
            let res = tab.value;
            if (multiple) {
                tab.selected = !tab.selected;
                if (tabs.filter(tm => tm.selected).length < 1) {
                    tab.selected = !tab.selected;
                }
                res = tabs.filter(tm => tm.selected).map(tm => tm.value).toString();
            }
            if (res === selectedAll) {
                tabs.forEach(tm => {
                    tm.selected = 0;
                });
            }
            this.limit[prop] = res;
            if (prop === 'provinces') {
                let record = this.area.provincesRecord;
                if (tab.value !== this.cp_provinces.selectedAll) {
                    record.unshift(tab);
                    this.area.provincesRecord = record.filter((itm, idx) => {
                        return record.findIndex(tm => tm.value === itm.value) === idx;
                    }).slice(0, 8);
                }
            }
            this.page.moreProvinces = false;
            if (typeof beforeCheck === 'function') {
                if (beforeCheck(this.limit, (send = {}) => {
                    this.queryBookLimit(send, 'update-ready');
                }, this.condition)) {
                    if (['country', 'provinces', 'city'].includes(prop)) {
                        this.$nextTick(() => {
                            this.$emit('limit-change');
                        });
                        return;
                    }
                    this.$emit('limit-change');
                };
            } else {
                if (['country', 'provinces', 'city'].includes(prop)) {
                    this.$nextTick(() => {
                        this.$emit('limit-change');
                    });
                    return;
                }
                this.$emit('limit-change');
            }
        },
        // 获取国家
        getCountry () {
            this.toggleLoading(true);
            this.condition.find((itm) => itm.prop === 'country').tabs = [];
            return api.getCountry().then((data) => {
                return {
                    key: 'country',
                    data: data.data,
                };
            });
        },
        // 获取所有省份
        getNewprovinces () {
            this.toggleLoading(true);
            this.condition.find((itm) => itm.prop === 'newprovinces').tabs = [];
            return api.getProvinces().then((data) => {
                return {
                    key: 'newprovinces',
                    data: data.data,
                };
            });
        },
        // 获取所有省份
        getYears () {
            this.toggleLoading(true);
            this.condition.find((itm) => itm.prop === 'years').tabs = [];
        },
        toggleLoading (p) {
            this.page.loading = p;
        },
        /* 按字母搜索省份 */
        clickLetter (l) {
            Object.assign(this.moreProvinces, {
                select: l,
                searchWord: '',
            });
            this.filterProv();
        },
        /* 关键字搜索 */
        searchKeywrd () {
            Object.assign(this.moreProvinces, {
                select: '',
                searchWord: this.moreProvinces.keyword,
            });
            this.filterProv();
        },
        /* 清空搜索 */
        clearSearchKey () {
            Object.assign(this.moreProvinces, {
                keyword: '',
                searchWord: '',
                select: 'A',
            });
        },
        dateChange () {
            this.$emit('limit-change');
        },
        /* 更新查询条件 */
        update (send) {
            return this.queryBookLimit(send);
        },
        filterProv () {
            let select = this.moreProvinces.select,
                keyword = this.moreProvinces.searchWord;
            this.filterProvArr = this.cp_provinces.tabs.filter(({ initials, label }) => {
                return initials === select || keyword.split('').some(itm => (initials.includes(itm) || label.includes(itm)));
            });
        },
        /* 教材知识点查询条件 */
        queryBookLimit (send = {}, type = 'update-ready') {
            this.toggleLoading(true);
            return api.dictionary(send).then(data => {
                if (data.errcode === 0) {
                    let list = data.data,
                        condition = this.condition,
                        admin = this.cp_admin;
                    /* 清空tabs */
                    this.cp_book_keys.forEach(key => {
                        (condition.find(c => c.prop === key) || {}).tabs = [];
                    });
                    list.forEach(itm => {
                        let temp = condition.find(cd => cd.prop === itm.id) || { tabs: [] };
                        if (!admin && itm.id === 'eduSystem') {
                            /* 非优学派和代理商，隐藏学制搜索项 */
                            return;
                        }
                        temp.tabs = (itm.label || []).map(lab => {
                            return {
                                label: lab.name,
                                value: lab.id,
                            };
                        });
                    });
                    this.$emit(type, this.condition);
                } else {
                    this.$message.error(data.errmsg);
                }
            }).finally(() => {
                this.toggleLoading(false);
            });
        },

    },
};
</script>

<style lang="scss">
  @import "../../sass/theme.scss";
  .condition-tabs {
    font-size: 14px;
    padding: 0 20px;
    line-height: 24px;
    min-height: 49px;
    table {
      width: 100%;
    }
    .tab-cell {
      vertical-align: top;
    }
    .td-all {
      width: 80px;
    }
    .item-tab-ul {
      margin-right: -15px;
      margin-bottom: -15px;
      overflow: hidden;
    }
    .tab-label {
      font-weight: 600;
      white-space: nowrap;
    }
    .item-tab {
      /*min-width: calc(100% / 10);*/
      padding-right: 20px;
      white-space: nowrap;
      margin-bottom: 15px;
      span {
        color: $gray-font;
        padding: 0 8px;
        display: inline-block;
        cursor: pointer;
        user-select: none;
        border-radius: 4px;
        border: 1px solid #ffff;
      }
      &.selected span {
        color: $primary;
        background: $light-primary;
        border-color: $primary;
      }
    }
    .btn-td {
      vertical-align: top;
    }
    .check-more-btn {
      padding-right: 40px !important;
      text-align: right;
    }
    tr {
      overflow: hidden;
    }
    .date-editor {
      margin-top: 8px;
    }
    .el-date-editor {
      display: block;
      line-height: 20px;
    }
    .el-date-editor .el-range-input {
      width: 98px;
    }
    .el-date-editor .el-range-separator {
      padding: 0;
    }
    .el-date-editor--daterange.el-input__inner {
      width: 280px;
    }
    .el-range-editor .el-range-input {
      line-height: 20px;
    }
    .el-radio {
      line-height: 28px;
    }
    .prov-ipt {
      width: 250px;
      margin-left: 20px;
    }
    .prov-label {
      /*flex: 0 0 150px;*/
    }
    .flex-between {
      flex: 1 1 auto;
      padding-left: 15px;
    }
    .prov-letter {
      padding: 0 5px;
      cursor: pointer;
      border-radius: 2px;
      user-select: none;
      &.selectd {
        background: $primary;
        color: #fff;
      }
    }
    .prov-result {
      padding: 0 15px;
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background: $gray-bg;
      }
      .prov-result-letter {
        width: 30px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        border-radius: 50%;
        color: #fff;
        background: $primary;
      }
    }
    .prov-ul {
      padding-top: 15px;
      .prov-result {
        margin-bottom: 15px;
      }
    }
    .prev-rol {
      padding: 15px 0;
      border-bottom: 1px solid $light-border;
    }
    .prev-record {
      ul {
        padding: 0 15px;
        margin-bottom: -15px;
      }
    }
    .tab-row {
      &:first-of-type td {
        border-top-color: transparent;
      }
      td {
        padding: 8px 0;
        border-top: 1px solid $gray-bg;
      }
      .tab-cont {
        padding-right: 15px;
      }
    }
    .tab-edu-system {
      .td-all span {
        display: none;
      }
      .over-ul {
        margin-left: -80px;
      }
    }
  }
  .more-province-dialog {
    .el-dialog__body{
      padding: 0 20px;
    }
  }

  .hidden-check {
    .td-all {
      display: none;
    }
  }
</style>
